import { render, staticRenderFns } from "./HomeIn.vue?vue&type=template&id=4cd20ae1&"
import script from "./HomeIn.vue?vue&type=script&lang=js&"
export * from "./HomeIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports